export default __webpack_public_path__ + "static/about_blixify-a8d6ec964865d910f186a3783cfea61f.png";